import allImgPaths from 'assets/images';
import React, { useState } from 'react';

const HistoryFileUpload = ({ fileName, fileSize, contentType }: any) => {
  const [fileExt, setFileExt] = useState<any>(fileName ? fileName.split('.').pop() : null)

  return (
    <>
      <div className="py-3 px-3 rounded-md shadow-customShadow10 bg-[#fff] border border-[#F2F4F7] mb-4 ml-14">
        <div className="flex gap-x-3 items-center">
          {
            fileExt === 'xlsx' &&
            <img className='' src={allImgPaths.fileTypeXLSXIcon} alt="" />
          }
          {
            fileExt === 'csv' &&
            <img className='' src={allImgPaths.fileTypeCSVIcon} alt="" />
          }
          {
            fileExt === 'pdf' &&
            <img className='' src={allImgPaths.fileTypePdfIcon} alt="" />
          }
          {
            fileExt === 'txt' &&
            <img className='' src={allImgPaths.fileTypePdfIcon} alt="" />
          }
          {
            (fileExt === 'doc' || fileExt === 'docx') &&
            <img className='' src={allImgPaths.fileTypeDOCXIcon} alt="" />
          }
          {
            (fileExt === 'jpg' || fileExt === 'jpeg' || fileExt === 'png') &&
            <img className='' src={allImgPaths.imageIcon} alt="" />
          }
          {
            (contentType != 'isRFP' || contentType != 'isRichTextContent' || contentType != 'isEmailTemplate') &&
            <div className="flex gap-x-2">
              <span className='text-sm text-[#101828] font-interMedium'>{fileName}</span>
              <span className='text-sm text-[#667085]'>{fileSize}</span>
            </div>
          }
        </div>
      </div>
    </>
  )
}

export default HistoryFileUpload;;